import React, { createContext, useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import useAPI from '../../hooks/useAPI';
import useUser from '../../hooks/useUser';
import log from '../../helpers/Logger';

export const NotificationBadgeContext = createContext();

export const NotificationBadgeProvider = ({ children }) => {
  const { id: userId, isAuth, workgroup } = useUser();
  const workgroupId = workgroup?.id;
  const [count, setCount] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const { getNotificationCount } = useAPI();
  const getNotificationCountRef = useRef(getNotificationCount);

  const fetchData = useCallback(
    () =>
      getNotificationCountRef
        .current({ viewed: false })
        .then((res) => setCount(res.count))
        .catch((e) => log.error('Failed to retrieve notifications count', e))
        .finally(() => setIsLoaded(true)),
    []
  );

  const refreshCount = () => fetchData();

  useEffect(() => {
    if (!userId || !isAuth) return;
    fetchData();

    const notificationInterval = setInterval(
      fetchData,
      process.env.REACT_APP_LAB_NOTIFICATIONS_COUNT_INTERVAL
    );

    // eslint-disable-next-line consistent-return
    return () => clearInterval(notificationInterval);
  }, [userId, isAuth, workgroupId, fetchData]);

  return (
    <NotificationBadgeContext.Provider
      value={{
        unreadNotifications: count,
        refresh: refreshCount,
        isLoaded,
      }}
    >
      {children}
    </NotificationBadgeContext.Provider>
  );
};

NotificationBadgeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
